import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { CmsService } from 'src/app/Services/cms.service';
import { environment } from "../../../../environments/environment";

@Component({
    selector: 'app-sobre-nos',
    templateUrl: './sobre-nos.component.html',
    standalone: false
})
export class SobreNosComponent implements OnInit{
  language: string = '';
  defaultLanguage: string = environment.defaultLanguage;

  about_content: string = 'linhas-sobre-no';
  aboutInfo: any = {};
  aboutInfoReady: boolean = false;


  constructor(
    private cmsService: CmsService,
    private router: Router,
    private translate: TranslateService,
    private title: Title
  ) {
    let lang = localStorage.getItem('language') ?? this.defaultLanguage;
    this.language = lang.split('-')[0];

    this.translate.get('navLinks').pipe().subscribe(trans => {
      let pageTitle =  trans['linhas'] + ' | ' + trans['sobre']
      this.title.setTitle(pageTitle);
    })
  }

  ngOnInit(){
    this.getContent();
  }

  getContent(){
    this.cmsService.getContentList(this.about_content, this.language).subscribe(
      {
        next: data => {
          this.aboutInfo = data['body']['data'];
          this.aboutInfoReady = true;
          
        },
        error: er => {
          this.router.navigate(['/500']);
        }
      }
    );
  }
}
